import React, { useState, useEffect } from "react";
// 1. Share2 ikonu ve html2pdf kütüphanesi eklendi
import { Printer, ArrowLeft, Share2 } from "lucide-react"; 
import { api } from "../../utils/api";
import PageHead from "../../components/PageHead";
import html2pdf from "html2pdf.js"; 

const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);
const money2 = n => new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
const fmtTR = d => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function Balance({ initialKodu, onBack }) {
  const [owners, setOwners] = useState([]);
  const [selected, setSelected] = useState(initialKodu || "");
  const [startDate, setStartDate] = useState("");
  const [data, setData] = useState(null);
  
  // 2. PDF oluşturulurken butonun durumunu değiştirmek için state eklendi
  const [isGenerating, setIsGenerating] = useState(false);

  const loadStatement = (code, s) => {
    if(!code) return;
    api.get(`/statement/${code}${s ? `?start=${s}` : ""}`).then(x => {
      setData(x.data);
      if (!s) setStartDate(x.data.start);
    }).catch(err => console.error("Hesap dökümü çekilemedi:", err));
  };

  useEffect(() => {
    api.get("/owners").then(r => {
      const sorted = (r.data || []).slice().sort((a, b) => 
        (a.owner_name || a.malik_adi || "").localeCompare(b.owner_name || b.malik_adi || "", "tr")
      );
      setOwners(sorted);
      const targetCode = initialKodu || sorted[0]?.accounting_code || sorted[0]?.hesap_kodu || "120.01";
      setSelected(targetCode);
      loadStatement(targetCode);
    });
  }, []);

  useEffect(() => {
    if (initialKodu && owners.length > 0) {
      setSelected(initialKodu);
      loadStatement(initialKodu, startDate);
    }
  }, [initialKodu]);

  const choose = e => {
    setSelected(e.target.value);
    loadStatement(e.target.value, startDate);
  };

  const changeStart = e => {
    setStartDate(e.target.value);
    loadStatement(selected, e.target.value);
  };

  // 3. DOĞRUDAN PDF OLUŞTURUP PAYLAŞTIRAN SİHİRLİ FONKSİYON
  const generateAndSharePDF = async () => {
    const element = document.getElementById('statement-print');
    if (!element) return;
    
    setIsGenerating(true);
    
    const ownerName = data?.owner?.owner_name || data?.owner?.malik_adi || selected;
    const fileName = `Baskent_Sitesi_Ekstre_${selected}.pdf`;

    const opt = {
      margin:       10,
      filename:     fileName,
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2, useCORS: true },
      jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    try {
      // HTML'i arka planda PDF dosyasına çevir
      const pdfBlob = await html2pdf().set(opt).from(element).output('blob');
      const file = new File([pdfBlob], fileName, { type: 'application/pdf' });

      // Cihazın paylaşma özelliği var mı kontrol et (Örn: Cep Telefonları)
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: 'Hesap Dökümü',
          text: `Sayın ${ownerName}, Başkent Sitesi hesap dökümünüz ektedir.`,
          files: [file]
        });
      } else {
        // Cihaz desteklemiyorsa (Örn: Masaüstü PC) otomatik olarak indir
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("PDF İşlemi Başarısız:", error);
      alert("PDF oluşturulurken bir hata meydana geldi.");
    } finally {
      setIsGenerating(false);
    }
  };

  const site = data?.settings?.site_name || "VADİ EVLERİ";

  return (
    <>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #statement-print, #statement-print * { visibility: visible !important; }
          #statement-print { position: absolute !important; left: 0 !important; top: 0 !important; width: 100% !important; margin: 0 !important; padding: 20px !important; }
          .no-print { display: none !important; }
        }
      `}</style>

      {onBack && (
        <div className="no-print" style={{ marginBottom: '16px' }}>
          <button 
            onClick={onBack} 
            data-testid="balance-back-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1B4332] text-white text-sm font-bold hover:bg-[#143326] transition-colors"
          >
            <ArrowLeft size={16} /> Geri Dön
          </button>
        </div>
      )}
      
      <PageHead 
        eyebrow="HESAP DÖKÜMÜ" 
        title="Bakiye raporu" 
        sub="Her malik için aylık aidat tahakkukları, ödemeler ve bakiye." 
        action={
          // 4. BUTON YENİ FONKSİYONA BAĞLANDI
          <button 
            className="secondary" 
            onClick={generateAndSharePDF} 
            disabled={isGenerating}
            style={{ display: "flex", alignItems: "center", gap: "8px", cursor: isGenerating ? "wait" : "pointer" }}
          >
            {isGenerating ? "PDF Hazırlanıyor..." : <><Share2 size={16}/> PDF Paylaş / İndir</>}
          </button>
        }
      />
      
      <section className="panel balance-selector no-print">
        <div>
          <span className="eyebrow">MALİK HESABI SEÇİN</span>
          <select value={selected} onChange={choose} data-testid="balance-owner-select">
            {owners.map(x => {
              const code = x.accounting_code || x.hesap_kodu;
              const name = x.owner_name || x.malik_adi || "(Boş)";
              const no = x.villa_no || x.daire_kodu || "—";
              return (
                <option key={code} value={code}>
                  {name} · {no} · {code}
                </option>
              );
            })}
          </select>
        </div>
        <div className="balance-actions">
          <label>Başlangıç tarihi
            <input type="date" value={startDate} onChange={changeStart} data-testid="balance-start-date"/>
          </label>
        </div>
      </section>
      
      {data && (
        <>
          <div className="balance-summary no-print">
            <div>
              <small>Toplam aidat</small>
              <strong>{money(data.totals.aidat)}</strong>
            </div>
            <div>
              <small>Toplam ödeme</small>
              <strong className="positive">{money(data.totals.payment)}</strong>
            </div>
            <div>
              <small>Güncel bakiye</small>
              <strong className={data.totals.balance > 0 ? "negative" : "positive"}>{money(data.totals.balance)}</strong>
              <span>{data.totals.balance > 0 ? "Borçlu" : "Alacaklı / Kapalı"}</span>
            </div>
          </div>
          
          <section className="panel statement" id="statement-print">
            <div className="statement-top">
              <div>
                <span className="eyebrow">{site.toUpperCase()}</span>
                <h3>ADI SOYADI: {data.owner?.owner_name || data.owner?.malik_adi || "—"}</h3>
                <p>Hesap kodu: <b>{selected}</b> · Villa No: <b>{data.owner?.villa_no || data.owner?.daire_kodu}</b> · Rapor tarihi: <b>{fmtTR(data.report_date)}</b></p>
              </div>
              <div className="statement-brand">{site[0] || "V"}<span>{site.toUpperCase()}</span></div>
            </div>
            
            <div className="table-panel">
              <table className="statement-table">
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>AY</th>
                    <th>YIL</th>
                    
                    <th className="right" style={{ width: "40px" }}>AİDAT<br /> TUTARI</th>
                    
                    <th>VADE<br /> TARİHİ</th>
                    <th className="right" style={{ width: "40px" }}>ÖDEME<br /> TUTARI</th>
                    <th>ÖDEME<br /> TARİHİ</th>
                    <th className="right">
                      KALAN BORÇLU(+)<br />
                      / ALACAKLI(-)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map(r => (
                    <tr key={r.no}>
                      <td>{r.no}</td>
                      <td>{r.ay}</td>
                      <td>{r.yil}</td>
                      
                      <td className="right">{money2(r.aidat_amount)}</td>
                      
                      <td>{fmtTR(r.aidat_date)}</td>
                      <td className="right">{r.payment_amount ? money2(r.payment_amount) : ""}</td>
                      <td dangerouslySetInnerHTML={{ __html: r.payment_date || "" }} />
                      <td className={`right ${r.balance > 0 ? "negative" : r.balance < 0 ? "positive" : ""}`}>
                        {money2(r.balance)}
                      </td>
                    </tr>
                  ))}
                  <tr className="totals-row">
                    <td colSpan="3" className="right"><b>TOPLAM</b></td>
                    <td className="right"><b>{money2(data.totals.aidat)}</b></td>
                    <td/>
                    <td className="right"><b>{money2(data.totals.payment)}</b></td>
                    <td/>
                    <td className={`right ${data.totals.balance > 0 ? "negative" : "positive"}`}>
                      <b>{money2(data.totals.balance)}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {!data.rows.length && <div className="empty">Bu hesaba ait kayıt bulunmuyor.</div>}
          </section>
        </>
      )}
    </>
  );
}